<mat-menu
    #baseMenu="matMenu"
    class="st-toolbar-menu__mat-menu">
    <ng-template matMenuContent>
        @for (item of localItems(); track $index) {
            @switch (item.type) {
                @case ('menu') {
                    <button
                        class="st-toolbar-menu__mat-menu__btn"
                        mat-menu-item
                        st-click-stop-propagation
                        [disabled]="item.disabled"
                        [matTooltip]="item?.label"
                        [matMenuTriggerFor]="menu.baseMenu()">
                        @if (item.showIcon) {
                            <mat-icon
                                class="st-toolbar-menu__mat-menu__icon"
                                [fontSet]="item.fontSet">
                                {{ item.icon }}
                            </mat-icon>
                        }
                        {{ item.label }}
                        @if (item.id === ToolbarMenuId.STORY_GENERATE && !environment.demoModeNotForProduction) {
                            <st-beta class="st-toolbar-menu__mat-menu__beta" />
                        }
                    </button>

                    <st-toolbar-menu
                        #menu
                        [items]="item.options"
                        (action)="action.emit($event)" />
                }
                @case ('action') {
                    @if (item.isDelete) {
                        <button
                            mat-menu-item
                            st-click-stop-propagation
                            class="st-toolbar-menu__mat-menu__delete-btn"
                            [disabled]="item.disabled"
                            [matTooltip]="item?.label"
                            (click)="onActionClick(item)">
                            @if (item.showIcon) {
                                <mat-icon
                                    class="st-toolbar-menu__mat-menu__icon"
                                    [fontSet]="item.fontSet">
                                    {{ item.icon }}
                                </mat-icon>
                            }
                            {{ item.label }}
                        </button>
                    } @else {
                        <button
                            mat-menu-item
                            st-click-stop-propagation
                            class="st-toolbar-menu__mat-menu__btn"
                            [class.st-toolbar-menu__mat-menu__btn--selected]="item.selected"
                            [class.st-toolbar-menu__mat-menu__btn__action-with-delete]="item.addDeleteBtnToAction"
                            [disabled]="item.disabled"
                            [matTooltip]="item?.label"
                            (click)="onActionClick(item)">
                            @if (item.showIcon) {
                                <mat-icon
                                    class="st-toolbar-menu__mat-menu__icon"
                                    [fontSet]="item.fontSet">
                                    {{ item.icon }}
                                </mat-icon>
                            }
                            <span class="st-toolbar-menu__mat-menu__btn__text">{{ item.label }}</span>
                            @if (item.commandType === ToolbarMenuCommandType.CHECKBOX) {
                                <mat-checkbox
                                    mat-suffix
                                    [checked]="item.checkboxValue" />
                            } @else if (item.selected) {
                                <div class="st-toolbar-menu__mat-menu__icon__selected">
                                    <mat-icon
                                        fontSet="material-symbols-outlined"
                                        class="st-toolbar-menu__mat-menu__icon">
                                        check
                                    </mat-icon>
                                </div>
                            }
                            @if (item?.addDeleteBtnToAction) {
                                <!-- TODO: This needs to be done with string template when we upgrade to Angular 19.2 and up.
E.G. [matTooltip]=${languageSettings.PSTRundownMenuDelete} ${item?.label} -->
                                <button
                                    mat-icon-button
                                    st-click-stop-propagation
                                    [matTooltip]="`${languageSettings.PSTRundownMenuDelete} ${item?.label}`"
                                    (click)="onAdditionalDeleteBtnClick(item)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            }
                        </button>
                    }
                }
                @default {
                    <mat-divider />
                }
            }
        }
    </ng-template>
</mat-menu>
